import axios from "../apis/django.instance";

export const getUserDetailsService = () => {
  return axios.get("/api/accounts/me/"); // must be in this format in order to mock implementation in unit test
};

export const getUserDetailsByIDService: GetUserDetailsByIdService = (
  userId
) => {
  return axios.get(`/api/accounts/get_user_details/${userId}/`); // must be in this format in order to mock implementation in unit test
};

export const updateUserDetailsService = (payload: AccountUser) => {
  const {
    avatar,
    full_name,
    display_name,
    email,
    timezone,
    country,
    city,
    what_i_do,
  } = payload;
  const formData = new FormData();
  if (avatar !== undefined && avatar !== null) {
    formData.append("avatar", avatar);
  }
  if (full_name !== undefined && full_name !== null) {
    formData.append("full_name", full_name);
  }
  if (display_name !== undefined && display_name !== null) {
    formData.append("display_name", display_name);
  }
  if (email !== undefined && email !== null) {
    formData.append("email", email);
  }
  if (timezone !== undefined && timezone !== null) {
    formData.append("timezone", timezone);
  }
  if (country !== undefined && country !== null) {
    formData.append("country", country);
  }
  if (city !== undefined && city !== null) {
    formData.append("city", city);
  }
  if (what_i_do !== undefined && what_i_do !== null) {
    formData.append("what_i_do", what_i_do);
  }
  return axios.patch("/api/accounts/me/", formData);
};
